import { createFileRoute } from "@tanstack/react-router";
import { motion } from 'framer-motion';

export const Route = createFileRoute("/politica-de-privacidade")({
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  return (
    <div className="bg-white">
      <section className="pt-40 pb-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center lg:text-left">
          <h1 className="text-3xl md:text-5xl font-bold text-primary mb-8">Política de Privacidade</h1>
          <div className="prose prose-lg max-w-none text-gray-600 leading-relaxed">
            <p>A sua privacidade é importante para nós. É política da STOP SOM respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site STOP SOM.</p>
            
            <h2 className="text-2xl font-bold text-primary mt-12 mb-6">1. Coleta de Informações</h2>
            <p>Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento.</p>
            
            <h2 className="text-2xl font-bold text-primary mt-12 mb-6">2. Uso das Informações</h2>
            <p>Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei.</p>
            
            <h2 className="text-2xl font-bold text-primary mt-12 mb-6">3. Armazenamento de Dados</h2>
            <p>Retemos as informações coletadas apenas pelo tempo necessário para fornecer o serviço solicitado.</p>
            
            <h2 className="text-2xl font-bold text-primary mt-12 mb-6">4. Cookies</h2>
            <p>Utilizamos cookies para melhorar sua experiência em nosso site.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
